var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    id: "list",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.33h-7.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.5c.41 0 .75.34.75.75s-.34.75-.75.75zM18 10.13h-7.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.5c.41 0 .75.34.75.75s-.34.75-.75.75zM6.89 10.96c-.19 0-.37-.07-.51-.2l-.89-.83c-.3-.28-.32-.76-.03-1.06.28-.3.76-.32 1.06-.03l.34.31 1-1.08c.28-.3.76-.32 1.06-.04.3.28.32.76.04 1.06l-1.51 1.63c-.14.15-.32.23-.52.24h-.03zM6.89 16.17c-.19 0-.37-.07-.51-.2l-.89-.83c-.3-.28-.32-.76-.03-1.06.28-.3.76-.32 1.06-.03l.34.31 1-1.08c.28-.3.76-.32 1.06-.04.3.28.32.76.04 1.06l-1.51 1.63c-.14.15-.32.23-.52.24h-.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,3.5c.83,0,1.5,.67,1.5,1.5v14c0,.83-.67,1.5-1.5,1.5H5c-.83,0-1.5-.67-1.5-1.5V5c0-.83,.67-1.5,1.5-1.5h14m0-1.5H5c-1.66,0-3,1.34-3,3v14c0,1.66,1.34,3,3,3h14c1.66,0,3-1.34,3-3V5c0-1.66-1.34-3-3-3h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.6b81356ebe998bf22992a8eeee2790ba.svg";
export { ForwardRef as ReactComponent };